export default __webpack_public_path__ + "static/media/whitening-logo.c8173dd2.png";